forms-locations-save  
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.c_name1")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.c_name2")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.name_alt")
    hr.mt-4.mb-4
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.country_code")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.postcode")
    inputs-select(tag-scope="{ this.tagScope }.inputs.statecode")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.address3")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.address2")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.address1")
    hr.mt-4.mb-4
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.option")
    inputs-submit(tag-scope="{ this.tagScope }.inputs.submit")
  script(type="typescript").
    this.mixin('forms.locations.save')
